const config = {
  apiKey: 'AIzaSyDpNjSAef3fv03iu-CxsKyUAELlawuIbF0',
  authDomain: 'cl-fibe-conf-lgtm-1302249.firebaseapp.com',
  databaseURL: 'https://cl-fibe-conf-lgtm-1302249.firebaseio.com',
  projectId: 'cl-fibe-conf-lgtm-1302249',
  storageBucket: 'cl-fibe-conf-lgtm-1302249.appspot.com',
  messagingSenderId: '690692677643',
};

export default config;
